export enum AccountType {
  PAYROLL = "PAYROLL",
  ALLOTMENT = "ALLOTMENT",
  COMPANY_ISSUE = "COMPANY_ISSUE",
}
